<template>
  <div
    class="fixed top-0 bg-skin-primary right-0 h-full md:absolute md:top-65 md:h-auto md:right-26 shadow-card rounded-sm z-50 w-full	md:w-250px"
  >
    <div class="p-22 pb-0 bg-skin-primary">
      <div class="flex justify-end">
        <Close @click="closeModal" class="cursor-pointer text-skin-secondary" />
      </div>

      <p
        class="font-bold text-l mb-30 md:mb-s capitalize text-skin-secondary"
        v-text="`${GET_USER.people_first_name} ${GET_USER.people_surnames}`"
      />

      <p
        @click="$router.push({ name: 'v2-profile' })"
        class="cursor-pointer py-12px w-full text-left border-t border-b font-medium	mb-30 md:mb-s text-skin-secondary"
      >
        Ver perfil
      </p>

      <ul class="font-medium">
        <li class="cursor-pointer mb-30 md:mb-s">
          <ModeSwitch />
        </li>
        <li
          class="cursor-pointer mb-30 md:mb-s text-skin-secondary"
          @click="$router.push({ name: 'v2-misCursos' })"
        >
          Mis cursos
        </li>
        <li
          class="cursor-pointer mb-30 md:mb-s flex justify-between text-skin-secondary"
          @click="$router.push({ name: 'v2-cart-buy' })"
        >
          Carrito de compras <Carrito />
        </li>
        <li
          class="cursor-pointer md:mb-s text-skin-secondary"
          @click="$router.push({ name: 'v2-facturacion' })"
        >
          Facturación
        </li>
        <li
          class="cursor-pointer md:mb-s text-skin-secondary"
          @click="$router.push({ name: 'v2-categories', query: { q: '' } })"
        >
          Explorar Cursos
        </li>
      </ul>
    </div>
    <div
      @click="logout()"
      class="absolute  rounded-b-sm md:relative bottom-0 md:flex items-center w-full bg-skin-secondary px-22 py-10px cursor-pointer"
    >
      <LogOut class="mr-s cursor-pointer inline-block text-skin-secondary" />
      <p class="cursor-pointer font-medium inline-block text-skin-secondary">
        Cerrar sesion
      </p>
    </div>
  </div>
</template>

<script>
import LogOut from "./icons/LogOut.vue";
import ModeSwitch from "./ModeSwitch.vue";
import Close from "./icons/Close.vue";
import Carrito from "./Carrito.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    LogOut,
    Close,
    ModeSwitch,
    Carrito,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("getUser", ["GET_USER"]),
  },
  methods: {
    closeModal() {
      this.$store.commit("openmodal", false);
    },
    logout() {
      this.$store.dispatch("logout/logout");
      this.$store.dispatch("auth/setStatusLogin", false);
      localStorage.clear();
      window.location.reload();
    },
  },
};
</script>
